// extracted by mini-css-extract-plugin
export default {"PatternDateWidget":"PatternDateWidget_PatternDateWidget__-HJEu","fromTo":"PatternDateWidget_fromTo__JfXqX","danger":"PatternDateWidget_danger__ZRHyG"};